import API from "./API";

class TicketPublic {
  static async create(data) {
    return await API.post("/public/tickets/", data, { needAuth: true });
  }

  static async createUnauthenticated(data) {
    return await API.post("/public/tickets/unauthenticated", data);
  }

  static async get(id) {
    return await API.get(`/public/tickets/${id}`);
  }

  static async cancel(id) {
    return await API.delete(`/public/tickets/${id}`, { needAuth: true });
  }

  static async cancelUnauthenticated(id, data) {
    return await API.delete(`/public/tickets/${id}/unauthenticated`, {
      params: data
    });
  }

  static async getUserTickets() {
    return await API.get(`/public/tickets/`, { needAuth: true });
  }
}

export default TicketPublic;
